interface RuntimeConfig {
  apiUrl: string;
  explorisHealthBaseUrl: string;
  deviceVersion: string | null;
}

let runtimeConfig: RuntimeConfig | null = null;

const defaultConfig: RuntimeConfig & { production: boolean } = {
  production: false,
  apiUrl: 'https://localhost:7248/api/',
  explorisHealthBaseUrl: 'https://www.explorishealth.com',
  deviceVersion: '1.5.0',
};

export async function loadRuntimeConfig(): Promise<void> {
  try {
    const response = await fetch('/api/config');
    if (response.ok) {
      runtimeConfig = await response.json();
      console.log('Runtime configuration loaded:', runtimeConfig);
    } else {
      console.warn('Failed to load runtime config, using defaults');
      runtimeConfig = defaultConfig;
    }
  } catch (error) {
    console.warn('Error loading runtime config, using defaults:', error);
    runtimeConfig = defaultConfig;
  }
}

export const environment = new Proxy(defaultConfig, {
  get(target, prop) {
    // If runtime config is loaded, use it; otherwise use defaults
    if (runtimeConfig && Object.prototype.hasOwnProperty.call(runtimeConfig, prop)) {
      return runtimeConfig[prop as keyof RuntimeConfig];
    }
    return target[prop as keyof typeof target];
  },
});
